import { useState, useEffect } from 'react'

import { familyGroupService } from '../services'

const useFamilyGroup = (option: 'FILTER' | '' = '') => {
  const [data, setData] = useState<any[] | null>(null)
  const [familyGroupsAsMember, setFamilyGroupsAsMember] = useState<any[] | null>(null)

  useEffect(() => {
    getFamilyGroupsAsMember()
  }, [])

  useEffect(() => {
    if(option === 'FILTER') getFamiliesFilter()
    else getFamilies()
  }, [option])

  const getFamilies = async () => {
    const resp = await familyGroupService.getFamilies()
    setData(resp.data && resp.data.families ? resp.data.families : [])
  }

  const getFamiliesFilter = async () => {
    const resp = await familyGroupService.getFamiliesFilter()
    setData(resp.data && resp.data.familyGroups ? resp.data.familyGroups : [])
  }

  const getFamilyGroupsAsMember = async () => {
    const resp = await familyGroupService.getFamilyGroupsAsMember()
    setFamilyGroupsAsMember(resp.data && resp.data.familyGroups ? resp.data.familyGroups : [])
  }

  return {
    data,
    familyGroupsAsMember,
    getFamilies,
    getFamilyGroupsAsMember
  }
}

export { useFamilyGroup }